import React from 'react'
import MessagesListPaginated from '../list-paginated'
import InboxMessage from './message'
import useMessages from '../../../hooks/use-messages-paginated'

const MessagesInboxDesktop = () => {
    const {
        isLoading,
        messages,
        total,
        offset,
        setOffset
    } = useMessages({
        box: 'in'
    })
    return (
        <MessagesListPaginated
            offset={offset}
            onOffsetChange={setOffset}
            messages={messages}
            total={total}
            messageComponent={InboxMessage}
            isLoading={isLoading}
        />
    )
}

export default MessagesInboxDesktop